import { webKnots } from '../../../common/back/lace/webKnots'
import { jointOfCatchFace, jointOfIndexFinger, jointOfThumbFinger2 } from './parts/earJointParts'
import { topSidePartOfWebForPicher } from './parts/sideParts'
import { webKnotDownward } from 'src/features/brands/treasure/canvas/common/back/lace/webKnotSingle'

export const wt9Web = (ctx: CanvasRenderingContext2D, webColor: string, laceColor: string, stitchColor: string): void => {
  ctx.lineWidth = 0.8
  ctx.strokeStyle = '#282828'
  // web先端の革パーツ
  topSidePartOfWebForPicher(ctx, webColor, laceColor, stitchColor)
  // ウェブ-人差し指のジョイントパーツ
  jointOfIndexFinger(ctx, webColor, laceColor, 3, 30)
  jointOfIndexFinger(ctx, webColor, laceColor, -24, 90)
  jointOfIndexFinger(ctx, webColor, laceColor, -45, 160)
  jointOfCatchFace(ctx, webColor, laceColor, -10, 12)
  jointOfCatchFace(ctx, webColor, laceColor, 38, 57)
  jointOfThumbFinger2(ctx, webColor, laceColor, -18, -5)
  // web本体のflatパーツ
  ctx.fillStyle = webColor
  ctx.beginPath()
  ctx.moveTo(549, 81) // 左上
  ctx.quadraticCurveTo(502, 166, 482, 247) // 左下1
  ctx.quadraticCurveTo(480, 256, 486, 268) // 左下2
  ctx.quadraticCurveTo(516, 326, 565, 357) // 右下1
  ctx.quadraticCurveTo(571, 362, 582, 362) // 右下2
  ctx.quadraticCurveTo(637, 324, 658, 303) // 右上1
  ctx.quadraticCurveTo(642, 165, 642, 165) // 右上2
  ctx.quadraticCurveTo(597, 105, 549, 81) // 左上
  ctx.fill()
  ctx.stroke()
  ctx.closePath()

  // stitchここから
  ctx.beginPath()
  ctx.strokeStyle = stitchColor
  ctx.setLineDash([3, 3])
  // 外側
  ctx.moveTo(552, 87) // 左上
  ctx.quadraticCurveTo(508, 166, 486, 252) // 左下
  ctx.quadraticCurveTo(505, 318, 581, 358) // 右下
  ctx.quadraticCurveTo(630, 326, 653, 302) //
  ctx.quadraticCurveTo(637, 165, 637, 165) //
  ctx.quadraticCurveTo(601, 117, 552, 87) //
  // 内側
  ctx.moveTo(555, 87) // 左上
  ctx.quadraticCurveTo(511, 166, 489, 252) // 左下
  ctx.quadraticCurveTo(505, 313, 581, 355) // 右下
  ctx.quadraticCurveTo(624, 326, 653, 296) //
  ctx.stroke()
  ctx.setLineDash([])
  ctx.strokeStyle = laceColor
  ctx.closePath()
  // stitchここまで
  webKnots(ctx, laceColor, -110, 110, 1) // ウェブ先端寄りのウェブ結び目
  laceParts1(ctx, laceColor)
  laceParts2(ctx, laceColor, 0, 0)
  laceParts2(ctx, laceColor, 3, 27)
  laceParts2(ctx, laceColor, 6, 54)
  laceParts2(ctx, laceColor, 7, 78)
  laceParts2(ctx, laceColor, 7, 105)

  laceParts3(ctx, laceColor, 0, 0)
  laceParts3(ctx, laceColor, 0, 29)
  laceParts3(ctx, laceColor, 1, 57)
  webKnotDownward(ctx, laceColor, -210, -650, 50)
  webKnotDownward(ctx, laceColor, -100, -570, 50)
}

const laceParts1 = (ctx: CanvasRenderingContext2D, laceColor: string) => {
  ctx.fillStyle = laceColor
  // 左1 _縦
  ctx.beginPath()
  ctx.moveTo(684, 172) // 左上
  ctx.quadraticCurveTo(668, 186, 645, 198) // 左下
  ctx.quadraticCurveTo(660, 203, 656, 204) // 右下
  ctx.quadraticCurveTo(674, 196, 688, 181) //
  ctx.quadraticCurveTo(689, 176, 684, 172) //
  ctx.fill()
  ctx.moveTo(686, 172) // 左上
  ctx.quadraticCurveTo(670, 188, 647, 198) // 左下
  ctx.stroke()
  ctx.closePath()

  // 左2
  ctx.beginPath()
  ctx.moveTo(693, 193) // 左上
  ctx.quadraticCurveTo(671, 214, 648, 226) // 左下
  ctx.quadraticCurveTo(657, 228, 659, 232) // 右下
  ctx.quadraticCurveTo(682, 220, 700, 201) //
  ctx.quadraticCurveTo(693, 193, 693, 193) //
  ctx.fill()
  ctx.moveTo(695, 193) // 左上
  ctx.quadraticCurveTo(674, 217, 648, 227) // 左下
  ctx.stroke()
  ctx.closePath()

  // 左3
  ctx.beginPath()
  ctx.moveTo(700, 218) // 左上
  ctx.quadraticCurveTo(672, 242, 654, 251) // 左下
  ctx.quadraticCurveTo(653, 262, 653, 262) // 右下
  ctx.quadraticCurveTo(678, 252, 706, 226) //
  ctx.quadraticCurveTo(705, 220, 700, 218) //
  ctx.fill()
  ctx.moveTo(702, 220) // 左上
  ctx.quadraticCurveTo(677, 242, 651, 256) // 左下
  ctx.stroke()
  ctx.closePath()

  // 左4
  ctx.beginPath()
  ctx.moveTo(708, 237) // 左上
  ctx.quadraticCurveTo(685, 259, 656, 274) // 左下
  ctx.quadraticCurveTo(656, 283, 658, 285) // 右下
  ctx.quadraticCurveTo(687, 275, 714, 245) //
  ctx.quadraticCurveTo(708, 237, 708, 237) //
  ctx.fill()
  ctx.moveTo(710, 237) // 左上
  ctx.quadraticCurveTo(688, 264, 656, 277) // 左下
  ctx.stroke()
  ctx.closePath()
}

const laceParts2 = (ctx: CanvasRenderingContext2D, laceColor: string, x: number, y: number) => {
  // 左4
  ctx.beginPath()
  ctx.moveTo(634 + x, 167 + y) // 左上
  ctx.quadraticCurveTo(630 + x, 177 + y, 633 + x, 179 + y) // 左下
  ctx.quadraticCurveTo(655 + x, 193 + y, 655 + x, 193 + y) // 右下
  ctx.quadraticCurveTo(665 + x, 187 + y, 665 + x, 187 + y) // 右上
  ctx.quadraticCurveTo(634 + x, 167 + y, 634 + x, 167 + y) //
  ctx.fill()
  ctx.moveTo(634 + x, 167 + y) // 左上
  ctx.quadraticCurveTo(634 + x, 172 + y, 665 + x, 187 + y) //
  ctx.stroke()
  ctx.closePath()
}

const laceParts3 = (ctx: CanvasRenderingContext2D, laceColor: string, x: number, y: number) => {
  ctx.fillStyle = laceColor
  // 左4
  ctx.beginPath()
  ctx.moveTo(665 + x, 200 + y) // 左上
  ctx.quadraticCurveTo(675 + x, 222 + y, 677 + x, 224 + y) // 左下
  ctx.quadraticCurveTo(682 + x, 224 + y, 686 + x, 218 + y) // 右下
  ctx.quadraticCurveTo(679 + x, 210 + y, 673 + x, 194 + y) // 右上
  ctx.quadraticCurveTo(665 + x, 200 + y, 665 + x, 200 + y) //
  ctx.fill()
  ctx.stroke()
  ctx.closePath()
}
